import { FC, PropsWithChildren } from 'react'

import { Button } from '@components/Button'

type Props = {
  theme: 'danger' | 'secondary' | 'light' | 'primary' | 'success' | 'info' | 'warning'
  isLoading?: boolean
  isDisabled?: boolean
  onClick: () => void
}

const QueueProcessCalledActionButton: FC<PropsWithChildren<Props>> = ({
  theme,
  isDisabled,
  isLoading,
  children,
  onClick,
}) => {
  return (
    <Button
      type="button"
      theme={theme}
      onClick={onClick}
      disabled={isDisabled}
      isLoading={isLoading}
      className="d-grid py-2 px-1"
    >
      <div className="d-flex flex-column justify-content-center align-items-center gap-1">{children}</div>
    </Button>
  )
}

export { QueueProcessCalledActionButton }
